import { useEffect, useRef, useState } from 'react'

export function useInactivityStatus(timeout = 5 * 60 * 1000) {
  const [isActive, setIsActive] = useState(false)
  const timeoutRef = useRef(null)
  const isActiveRef = useRef(false) // mirrors state without causing re-renders

  useEffect(() => {
    const setInactive = () => {
      if (isActiveRef.current) {
        isActiveRef.current = false
        setIsActive(false)
      }
    }

    const resetTimer = () => {
      if (!isActiveRef.current) {
        isActiveRef.current = true
        setIsActive(true)
      }

      if (timeoutRef.current) clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(setInactive, timeout)
    }

    const events = ['mousemove', 'keydown', 'scroll', 'touchstart']

    events.forEach((event) => window.addEventListener(event, resetTimer, { passive: true }))

    // Do not call resetTimer() on mount — isActive stays false until first user event,
    // preventing autoplay from starting before any interaction (avoids CLS on page load).

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
      events.forEach((event) => window.removeEventListener(event, resetTimer))
    }
  }, [timeout])

  return isActive
}
export default useInactivityStatus
